import Axios from 'axios'
import Vue from 'vue'
import router from './router'
//import SECRETS from '../.secrets.development.js'

const http = Axios.create({
    baseURL: `${process.env.VUE_APP_FLASK_HOST}/api/v1`,
    // baseURL: `${SECRETS.FLASK_HOST}/api/v1`,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json; charset=UTF-8",
        "X-Requested-With": "XMLHttpRequest"
    },
})

let refreshTokenPromise;

const getRefreshToken = () => http.post('/token/refresh', {}, {
    withCredentials: true,
    headers: {
        'X-CSRF-TOKEN': Vue.$cookies.get('csrf_refresh_token'),
        'Authorization': `Bearer ${Vue.$cookies.get("csrf_refresh_token")}`
    }
}).then(() => Vue.$cookies.get('csrf_access_token'))

http.interceptors.response.use(r => r, error => {
    if (error.config && error.response && error.response.status === 401 &&
        error.response.data && error.response.data.msg === 'Token has expired' && !error.config._retry) {
        if (!refreshTokenPromise) {
            error.config._retry = true;
            refreshTokenPromise = getRefreshToken().then(token => {
                refreshTokenPromise = null
                return token
            })
        }

        return refreshTokenPromise.then(token => {
            error.config.headers['X-CSRF-TOKEN'] = token
            return http.request(error.config)
        })
    }
    return Promise.reject(error)
})

export default http
